var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconNavMargin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1845_42769)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.80124 6.86613C1.65187 7.01534 1.53338 7.19253 1.45254 7.38757C1.37169 7.5826 1.33008 7.79166 1.33008 8.00279C1.33008 8.21392 1.37169 8.42298 1.45254 8.61802C1.53338 8.81305 1.65187 8.99024 1.80124 9.13946L6.86124 14.1995C7.01046 14.3488 7.18765 14.4673 7.38268 14.5482C7.57772 14.629 7.78678 14.6706 7.99791 14.6706C8.20904 14.6706 8.4181 14.629 8.61313 14.5482C8.80817 14.4673 8.98536 14.3488 9.13458 14.1995L14.1946 9.13946C14.3439 8.99024 14.4624 8.81305 14.5433 8.61802C14.6241 8.42298 14.6657 8.21392 14.6657 8.00279C14.6657 7.79166 14.6241 7.5826 14.5433 7.38757C14.4624 7.19253 14.3439 7.01534 14.1946 6.86613L9.13458 1.80612C8.98536 1.65676 8.80817 1.53826 8.61313 1.45742C8.4181 1.37657 8.20904 1.33496 7.99791 1.33496C7.78678 1.33496 7.57772 1.37657 7.38268 1.45742C7.18765 1.53826 7.01046 1.65676 6.86124 1.80612L1.80124 6.86613Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.13281 6.13379H6.13948",
    stroke: "currentColor",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.66732 6.33301L6.33398 9.66634",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.79883 9.86621H9.80549",
    stroke: "currentColor",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1845_42769"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNavMargin);
export default __webpack_public_path__ + "static/media/icon-nav-margin.34e40dd940f498db480f7c8f92618bd4.svg";
export { ForwardRef as ReactComponent };